<template>
    <section>
        <div class="container container-top">
            <div class="col-left">
                <div class="textos">
                    <div class="texto">
                        <p>Mais de<br>
                        <span class="bigtext" id="counter-client">0</span><br>
                        clientes dentre as 500 maiores empresas brasileiras</p>
                    </div>
                </div>
            </div>
            <div class="col-center">
                <div class="textos">
                    <div class="texto">
                        <p>Mais de<br>
                        <span class="bigtext"><span id="counter-candidates">0</span></span><span class="mediumtext">milhões</span><br>
                        de candidatos em games de seleção</p>
                    </div>
                </div>
            </div>
            <div class="col-right">
                <div class="textos">
                    <div class="texto">
                        <p>Mais de<br>
                        <span class="bigtext" id="counter-games">0</span><br>
                        títulos de games corporativos, formando o maior portfólio do Brasil</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="container container-bottom">
            <div class="col-unique">
                <button class="btn-gradient" @click="goPage('#formcard')">Quero revolucionar a aprendizagem corporativa</button>
            </div>
        </div>
    </section>
</template>
<script>
import gsap from "gsap";
// import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
export default {
    methods: {
        goPage(value) {
            this.menuStatus = false;
            // this.$scrollTo(value);
            this.$emit("unlockAll")
            this.sleep().then(() => {
                this.$nextTick(() => {
                    this.$scrollTo(value, {
                        offset: 0
                    });
                });
            })
        },
        sleep: function (ms = 100) {
            return new Promise(resolve => setTimeout(resolve, ms))
        }
    },
    mounted() {
        gsap.registerPlugin(ScrollTrigger);
        gsap.to("#counter-client", { 
            scrollTrigger: "#counter-client", 
            toogleActions: "restart none none pause",
            innerText: 130, 
            duration: 3, 
            snap: {
                innerText:5
            } 
        });
        gsap.to("#counter-candidates", { 
            scrollTrigger: "#counter-candidates", 
            toogleActions: "restart none none pause",
            innerText: 2, 
            duration: .5, 
            snap: {
                innerText:1
            } 
        });
        gsap.to("#counter-games", { 
            scrollTrigger: "#counter-games", 
            toogleActions: "restart none none pause",
            innerText: 300, 
            duration: 3, 
            snap: {
                innerText:5
            } 
        });
    }
}
</script>
<style lang="scss" scoped>
section {
    .container-top {
        padding-top: 96px;
        padding-bottom: 96px;
        align-items: flex-start;
        .textos {
            // padding-top: 63px;
            display: flex;
            flex-direction: row;
            // gap: 30px;
            flex-wrap: wrap;
            justify-content: flex-start;
            align-items: flex-start;
            .texto {
                max-width: 248px;
                display: flex;
                // flex-basis: 47%;
                .bigtext {
                    font-size: 5.05rem;
                    font-weight: 900;
                    color: $color-primary;
                    line-height: 5rem;
                }
                .mediumtext {
                    font-size: 2.05rem;
                    font-weight: 900;
                    color: $color-primary;
                    line-height: 2rem;
                }
            }
        }
    }
    .container-bottom {
        padding-bottom: 96px;
    }
    @media only screen and (max-width: 720px) {
        .container {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .textos {
                .texto {
                }
            }
            .col-left, .col-center {
                padding-bottom: 60px;
            }
            .col-left, .col-right, .col-center, .col-unique {
                margin-left: $column-lateral-margin-mobile;
                margin-right: $column-lateral-margin-mobile;
            }
        }
    }
}
</style>